import { tr } from "../lib/i18n";

const SELECTS = [
  ["poster_style", "sg.poster_style", [["solid", "sg.style_solid"], ["outline", "sg.style_outline"], ["ribbon", "sg.style_ribbon"]]],
  ["auto_template", "sg.auto_template", [["square", "sg.t_square"], ["portrait", "sg.t_portrait"], ["story", "sg.t_story"], ["carousel", "sg.t_carousel"]]],
  ["auto_lang", "sg.auto_lang", [["en", "sg.lang_en"], ["ar", "sg.lang_ar"], ["both", "sg.lang_both"]]],
  ["auto_background", "sg.auto_background", [["", "sg.bg_original"], ["showroom", "sg.bg_showroom"], ["studio", "sg.bg_studio"], ["muscat", "sg.bg_muscat"]]],
];

export default function PosterSettingsFields({ form, set, canEdit }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="poster-settings">
      {SELECTS.map(([k, label, opts]) => (
        <label key={k} className="block">
          <span className="eyebrow">{tr(label)}</span>
          <select className="input mt-2" value={form[k] ?? ""} disabled={!canEdit} onChange={(e) => set(k, e.target.value)} data-testid={`social-${k.replace(/_/g, "-")}`}>
            {opts.map(([v, l]) => <option key={v} value={v}>{tr(l)}</option>)}
          </select>
        </label>
      ))}
      <label className="flex items-center gap-2 text-sm md:col-span-2">
        <input type="checkbox" checked={form.auto_draft !== false} disabled={!canEdit} onChange={(e) => set("auto_draft", e.target.checked)} data-testid="social-auto-draft" />
        {tr("sg.auto_draft")}
      </label>
      <p className="text-[11px] text-[var(--gray-400)] md:col-span-2">{tr("sg.auto_bg_hint")}</p>
    </div>
  );
}
